import { $get } from '../'

export function $sum (values: Array<any>, field?: string, multiplier?: string | number) {
  return values.reduce((sum:number, n) =>
    field?.length
      ? sum + parseFloat($get(n, field, 0)) * (typeof multiplier === 'number' ? multiplier : parseFloat($get(n, multiplier as any, 1)))
      : (sum + (parseFloat(n) * parseFloat(multiplier as string || '1')))
  , 0)
}

export const $factor = (value, factor = 1) => Math.round( value * (10 ** factor))

export function $minmax (value, min, max) {
  return Math.min(max, Math.max(value, min))
}
